import { Box, Card, Flex, FlexProps, Heading, Text } from '@radix-ui/themes';
import { ReactNode } from 'react';

import styles from './Charts.module.css';

type ChartBoxProps = FlexProps & {
    title?: string;
    subTitle?: string;
    legend?: ReactNode;
};

export const ChartBox = ({
    title,
    subTitle,
    legend,
    children,
    ...props
}: ChartBoxProps) => (
    <Card
        size='2'
        style={{
            height: '100%',
            width: '100%',
            padding: 0,
            flexGrow: 1,
        }}
    >
        <Flex height='100%' justify={'between'}>
            <Flex direction={'column'} justify={'between'} gap={'2'} p={'4'}>
                <Flex direction={'column'} gap={'2'}>
                    {title && (
                        <Heading
                            size='4'
                            weight='medium'
                            color='gray'
                            wrap={'pretty'}
                            highContrast
                        >
                            {title}
                        </Heading>
                    )}

                    {subTitle && (
                        <Text size={'7'} weight={'bold'} color='gray'>
                            {subTitle}
                        </Text>
                    )}
                </Flex>

                {legend && <Box flexShrink={'0'}>{legend}</Box>}
            </Flex>

            <Flex
                className={styles.chartBox}
                height={'100%'}
                flexGrow={'1'}
                align={'end'}
                justify={'center'}
                {...props}
            >
                {children}
            </Flex>
        </Flex>
    </Card>
);
